import InfoIcon from '@src/svgs/InfoIconAlt';
import { destructureImpactScore } from '@src/utility/impactScore';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import styled from 'styled-components';

import MetricsTooltip from './MetricsTooltip';

import type { ClipFragment } from '@src/services/AIClipProducer';

export { destructureImpactScore };

export default function ImpactScoreBadge({
  impactScore,
  id, // for tooltip ID
}: {
  impactScore: ClipFragment['impactScore'];
  id: string;
}) {
  if (!impactScore || Object.keys(impactScore).length === 0) {
    return null;
  }

  const { main, ...rest } = destructureImpactScore(impactScore);

  return (
    <Wrapper>
      <BadgeWrapper data-tooltip-id={`${id}-tooltip`} data-tooltip-content="-">
        <Badge>{main}</Badge>
        <IconWrapper>
          <InfoIcon width="12" height="12" />
        </IconWrapper>
      </BadgeWrapper>
      <ReactTooltip
        id={`${id}-tooltip`}
        render={() => (
          <MetricsTooltip
            mainMetric={{ name: 'Impact Score', value: main }}
            otherMetrics={rest}
          />
        )}
        style={{
          background: 'none',
          zIndex: 1000003,
        }}
        place="right-start"
        offset={-30}
      />
    </Wrapper>
  );
}

const Badge = styled.div`
  color: var(--primary);
  font-family: var(--font-primary);
  font-size: 28px;
  font-style: normal;
  font-weight: var(--font-weight-bold);
  line-height: normal;
`;

const IconWrapper = styled.div`
  color: var(--text-muted);
`;

const BadgeWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-2xs);
`;

const Wrapper = styled.div`
  z-index: 2;
  --rt-opacity: 1;
`;
